import { bootstrapApplication } from '@angular/platform-browser';
import { App } from '@taxora-business-shell/app';
import { appConfig } from '@taxora-business-shell/app.config';

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
